import React from 'react';

import './styles.css';

const Description = ({option}) => (
  <div className="Description">
    <div className="DescriptionLabel">{option.label}</div>
    <div className="DescriptionCapacity">{option.capacity}</div>
  </div>
);

export default Description;
